import { j as e } from "./jsx-runtime-DmTjM30f.mjs";
import * as t from "react";
import { forwardRef as n } from "react";
import { c as m } from "./index.js-Cr0Rsuyz.mjs";
import { c as o } from "./tw-cn-mXgPecoF.mjs";
import { c as s } from "./index-BpNK5r1N.mjs";
function p(a, l) {
  return /* @__PURE__ */ t.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, a), /* @__PURE__ */ t.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.693 3.123a1.465 1.465 0 0 1 1.945-.652l.008.004c.285.142.512.37.655.655l.002.004 2.252 4.564c.052.108.14.17.248.185h.007l5.032.75.029.006c.765.132 1.325.84 1.2 1.65l-.002.017-.003.017c-.057.281-.191.559-.415.783l-.007.007-3.63 3.54a.38.38 0 0 0-.105.316l.862 5.02c.125.789-.412 1.519-1.18 1.663a1.46 1.46 0 0 1-.926-.136l-.007-.003-4.507-2.374-.003-.001a.33.33 0 0 0-.316 0l-.002.001-4.507 2.374-.007.003c-.257.129-.512.16-.716.16h-.029l-.028-.003a1.44 1.44 0 0 1-.744-.27 1.5 1.5 0 0 1-.491-.629l-.014-.033-.01-.035a1.6 1.6 0 0 1-.065-.724l.002-.013.86-5.007v-.001a.34.34 0 0 0-.09-.305l-.005-.003-3.646-3.557a1.46 1.46 0 0 1-.033-2.037c.238-.271.56-.407.849-.446l5.026-.73h.002a.36.36 0 0 0 .255-.191V7.69zm1.302.75L9.781 8.362c-.265.53-.78.92-1.384 1.007l-4.945.718 3.58 3.491c.448.432.626 1.045.528 1.632v.004l-.846 4.925 4.414-2.325h.002a1.83 1.83 0 0 1 1.72 0h.002l4.424 2.33-.845-4.92c-.103-.601.105-1.198.508-1.617l.009-.009 3.583-3.494-4.938-.735a1.82 1.82 0 0 1-1.386-1.013z",
    clipRule: "evenodd"
  }));
}
var h = m(/* @__PURE__ */ n(p));
function v(a, l) {
  return /* @__PURE__ */ t.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, a), /* @__PURE__ */ t.createElement("path", {
    fill: "currentColor",
    d: "M12.638 2.471a1.465 1.465 0 0 0-1.945.652L8.44 7.69v.002a.36.36 0 0 1-.255.191h-.002l-5.026.73c-.289.04-.61.175-.85.446a1.462 1.462 0 0 0 .033 2.037l3.647 3.557.004.003c.07.068.112.174.09.305v.001l-.86 5.007-.001.013c-.043.28.005.53.064.724l.01.035.015.033c.096.23.256.457.491.628.233.17.488.252.744.271l.028.003h.03c.203 0 .458-.031.715-.16l.007-.003 4.507-2.374.002-.001a.33.33 0 0 1 .316 0l.003.001 4.507 2.374.007.003c.259.13.586.203.926.136a1.466 1.466 0 0 0 1.18-1.663l-.862-5.02a.38.38 0 0 1 .106-.317l3.629-3.54.007-.006c.224-.224.358-.502.415-.783l.003-.017.002-.016a1.45 1.45 0 0 0-1.2-1.651l-.029-.007-5.031-.748-.008-.001a.32.32 0 0 1-.248-.185l-2.252-4.564-.002-.004a1.46 1.46 0 0 0-.655-.655z"
  }));
}
var y = m(/* @__PURE__ */ n(v));
const u = s("", {
  variants: {
    size: {
      xlarge: "size-40",
      large: "size-18",
      medium: "size-16",
      small: "size-12"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), f = s("", {
  variants: {
    size: {
      xlarge: "typography-headline-40-bold",
      large: "typography-subtitle-16-bold",
      medium: "typography-body-14-bold",
      small: "typography-body-12-bold"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), x = s("", {
  variants: {
    size: {
      xlarge: "typography-headline-32-regular",
      large: "typography-body-14-regular",
      medium: "typography-body-14-regular",
      small: "typography-body-12-regular"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), j = ({ iconType: a = "starFill", score: l, reviewCount: c, size: r }) => {
  const i = u({ size: r }), g = f({ size: r }), d = x({ size: r });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex items-center space-x-2", children: [
    a === "starFill" ? /* @__PURE__ */ e.jsx(y, { className: i }) : /* @__PURE__ */ e.jsx(h, { className: i }),
    /* @__PURE__ */ e.jsx("span", { className: o(g, "font-bold"), children: l }),
    !!c && /* @__PURE__ */ e.jsxs("span", { className: o(d), children: [
      "(",
      c,
      ")"
    ] })
  ] });
};
export {
  j as S
};
